import {
  apiUpdatePaso,
  apiInsertarDatosPersonales,
  apiInsertarSegurosEstudiante,
  apiListaDatosPersonales,
  apiGrupos,
  apiListaAsignaturasEstudiante,
  apiListaEmpresasSeguro,
  apiCierreMatricula,
  apiValidarSeguroUpch,
  API_CONSTACIAS_HABILITADAS,
  API_DATOS_CONSTACIA,
  API_DATOS_HORARIO,
  API_CRONOGRAMA_PAGO,
  API_RUTA_CONSTANCIA,
  API_SEGURO_DATOS,
  API_SEGURO_PRELIQUIDACION,
  API_REGISTRO_PAGOEXITO,
  API_REGISTRO_RESPUESTAPASARELA,
  API_LISTAS_HABILITADAS,
  API_LISTAS_PREGUNTAS,
  API_SESIONESHABILITADAS,
  apiAsignatura,
  API_UPLOADFILE,
  API_RESPUESTAS,
  codigoIntitucion,
  apiDatosEstudiante,
  keyPassLogin,
  apiPasarelaSafetyPay,
  KEY_SAFETY_PAY,
  apiCierreMatriculaControlado,
  apiGenerarProcesoEstudiante,
  apiValidarErrorProceso,
} from "../../config/constantes";
import CryptoJS from "crypto-js";

const prometeValidarApi = (api, config, msgAdd = "") => {
  return new Promise((resolver, rechazar) => {
    fetch(api, config)
      .then((data) => {
        if (data.status === 200 || data.status === 400) {
          resolver(data);
        } else {
          rechazar(new Error(data));

        }
      })
      .catch(error => {
        rechazar(new Error(`Error en la solicitud a la API ${msgAdd}: ` + error.message));
      });
  });
};


const prometeValidarApiCierreMatricula = (api, config, msgAdd = "") => {
  return fetch(api, config)
    .then(response => {

      return response.json().then(data => {
        if (data.status === 200 || data.status === 400) {
          return data;
        } else {

          const error = new Error(`Error en la solicitud: status ${data.status}`);
          error.statusCode = data.status;
          return Promise.reject(error);
        }
      });
    })
    .catch(error => {
      if (error instanceof TypeError && error.message === 'Failed to fetch') {
        return Promise.resolve({
          status: 504,
          data: null,
          message: 'Gateway Timeout (504) - No se recibió respuesta'
        });
      } else {
        return Promise.reject(error);
      }
    });
};






const prometeValidarApiPasarela = (api, config) => {
  return new Promise((resolver, rechazar) => {
    fetch(api, config).then((data) => {
      if (data.status === 200 || data.status === 201 || data.status === 202) {
        resolver(data);
      } else {
        rechazar(new Error(data));
      }
    });
  });
};

const prometeValidarApi2 = (api, config) => {
  return new Promise((resolver, rechazar) => {
    fetch(api, config).then((data) => {

      if (data.status === 200 || data.status === 201 || data.ok === true) {
        resolver(data);
      } else {
        rechazar(new Error(data));
      }
    });
  });
};

let update_paso = async (datosEstudiante, paso, pasopago) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: cinstitucion,
        p_cprograma: cprograma,
        p_cperiodo: cperiodo,
        p_cpersona: cpersona,
        p_paso: paso,
        p_pasopago: pasopago,
      }),
    };
    try {
      const updatePaso = await prometeValidarApi(`${apiUpdatePaso}`, config);

      const updatePasoJson = await updatePaso.json();
      const { Data } = updatePasoJson;
      return updatePasoJson;
      // setlistadoRequisitosMatricula(Data);
    } catch (error) {
      throw error;
    }
  }
};

let update_datosPersonales = async (datosPersonales, inputs) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cpersona } = datosPersonales;
  const { celular, correo } = inputs;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cpersona: cpersona,
        p_ncelular: String(celular),
        p_tcorreo: correo,
        p_tdireccion: "",
      }),
    };
    try {
      // apiInsertarDatosPersonales
      const updateDatosPersonales = await prometeValidarApi(
        `${apiInsertarDatosPersonales}`,
        config
      );

      const updateDatosPersonalesJson = await updateDatosPersonales.json();
      const { Data } = updateDatosPersonalesJson;

      return updateDatosPersonalesJson;
      // setlistadoRequisitosMatricula(Data);
    } catch (error) {
      throw error;
    }
  }
};

let update_seguroEstudiante = async (datosEstudiante, inputs) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;
  const {
    radioSeguros,
    empresaSeguro,
    fechaVencimiento,
    numeroPoliza,
    nombreArchivo,
    aceptoTerminos,
    bases64,
    tipoArchivo,
    p_empresa_especificar,
    p_cusuario,
    p_id_seguro,
    p_cnombrearchivo_anterior,
    p_fvcto_nulo,
  } = inputs;

  let fecha =
    fechaVencimiento !== "" && fechaVencimiento !== null
      ? String(new Date(fechaVencimiento).toISOString()).slice(0, -1) + "904"
      : fechaVencimiento;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },

      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_cpoliza: String(numeroPoliza),
        p_fvencimiento: fecha,
        p_cnombrearchivo: String(nombreArchivo),
        p_cseguro: Number(empresaSeguro),
        p_tipo: Number(radioSeguros),
        p_acepto: aceptoTerminos,
        p_ctipoarchivo: String(tipoArchivo),
        p_darchivo: String(bases64),
        p_empresa_especificar: String(p_empresa_especificar),
        p_cusuario,
        p_id_seguro,
        p_cnombrearchivo_anterior,
        p_fvcto_nulo,
      }),
    };
    try {
      const updateDatosSeguroEstudiante = await prometeValidarApi(
        `${apiInsertarSegurosEstudiante}`,
        config
      );

      const updateDatosSeguroEstudianteJson =
        await updateDatosSeguroEstudiante.json();
      const { Data } = updateDatosSeguroEstudianteJson;

      return updateDatosSeguroEstudianteJson;
      // setlistadoRequisitosMatricula(Data);
    } catch (error) { }
  }
};

let listado_datos_personales = async (
  datosEstudiante,
  setListadoDatosPersonales,
  setLoading
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cpersona } = datosEstudiante;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cpersona: cpersona,
      }),
    };
    try {
      setLoading(true);
      const listaDatosPersonales = await prometeValidarApi(
        `${apiListaDatosPersonales}`,
        config
      );

      const listaDatosPersonalesJson = await listaDatosPersonales.json();
      const { Data } = listaDatosPersonalesJson;
      setListadoDatosPersonales(Data);
    } catch (error) {
      setLoading(false);
      throw error;
    } finally {
      setLoading(false);
    }
  }
};

let listado_datos_personalesReturn = async (
  datosEstudiante,
  setLoading,
  sinLoading = false
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cpersona } = datosEstudiante;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cpersona: cpersona,
      }),
    };
    try {
      if (sinLoading == false) {
        setLoading(true);
      }

      const listaDatosPersonales = await prometeValidarApi(
        `${apiListaDatosPersonales}`,
        config
      );

      const listaDatosPersonalesJson = await listaDatosPersonales.json();
      const { Data, Code, Message } = listaDatosPersonalesJson;

      if (String(Code) === "0") {
        throw new Error(Message);
      }
      return Data;
    } catch (error) {
      if (sinLoading == false) {
        setLoading(false);
      }
      throw error;
    } finally {
      if (sinLoading == false) {
        setLoading(false);
      }
    }
  }
};

let listado_grupos_habilitados = async (
  datosEstudiante,
  setGruposHabilitados
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: Number(cinstitucion),
      p_cprograma: Number(cprograma),
      p_cperiodo: Number(cperiodo),
      p_cpersona: Number(cpersona),
    }),
  };
  try {
    const listaCursos = await prometeValidarApi(`${apiGrupos}`, config);

    const listaCursosJson = await listaCursos.json();
    const { Data } = listaCursosJson;

    let listOrdenadaEquivalente = Data.sort(function (a, b) {
      if (a.dcurso < b.dcurso) {
        return -1;
      }
      if (a.dcurso > b.dcurso) {
        return 1;
      }

      if (a.dequivalente < b.dequivalente) {
        return -1;
      }
      if (a.dequivalente > b.dequivalente) {
        return 1;
      }

      return 0;
    });


    setGruposHabilitados(listOrdenadaEquivalente);

  } catch (error) {
    throw error;
  }
};

let listado_asignaturas_estudiante = async (
  datosEstudiante,
  setListadoAsignaturasEstudiante,
  setLoading
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: cinstitucion,
        p_cprograma: cprograma,
        p_cperiodo: cperiodo,
        p_cpersona: cpersona,
      }),
    };
    try {
      setLoading(true);
      const listaAsignaturasEstudiante = await prometeValidarApi(
        `${apiListaAsignaturasEstudiante}`,
        config
      );

      const listaAsignaturasEstudianteJson =
        await listaAsignaturasEstudiante.json();
      const { Data } = listaAsignaturasEstudianteJson;
      let listOrdenadaEquivalente = Data.sort(function (a, b) {
        if (a.dcurso > b.dcurso) {
          return 1;
        }
        if (a.dcurso < b.dcurso) {
          return -1;
        }


        return 0;
      });
      setListadoAsignaturasEstudiante(listOrdenadaEquivalente);
      return listOrdenadaEquivalente;
    } catch (error) {
      setLoading(false);
      throw error;
    } finally {
      setLoading(false);
    }
  }
};

let listado_asignaturas_estudiante_sinLoading = async (
  datosEstudiante,
  setListadoAsignaturasEstudiante
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: cinstitucion,
        p_cprograma: cprograma,
        p_cperiodo: cperiodo,
        p_cpersona: cpersona,
      }),
    };
    try {
      const listaAsignaturasEstudiante = await prometeValidarApi(
        `${apiListaAsignaturasEstudiante}`,
        config
      );

      const listaAsignaturasEstudianteJson =
        await listaAsignaturasEstudiante.json();
      const { Data } = listaAsignaturasEstudianteJson;

      let listOrdenadaEquivalente = Data.sort(function (a, b) {
        if (a.dcurso > b.dcurso) {
          return 1;
        }
        if (a.dcurso < b.dcurso) {
          return -1;
        }

        return 0;
      });
      setListadoAsignaturasEstudiante(listOrdenadaEquivalente);
    } catch (error) {
      throw error;
    }
  }
};

let insertCierreMatricula = async (datosEstudiante, inputs) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona, calumno, dperiodo, } = datosEstudiante;
  const { cursosmatriculados, ntransaccion, cproceso, ccarrera, caplicacion } = inputs;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_ntransaccion: Number(ntransaccion),
        p_calumno: Number(calumno),
        p_dperiodo: String(dperiodo),
        p_cursosmatriculados: cursosmatriculados,
        p_cproceso: cproceso,
        p_ccarrera: Number(ccarrera),
        p_caplicacion: Number(caplicacion)
      }),
    };
    try {
      const updateCierreMatricula = await prometeValidarApiCierreMatricula(`${apiCierreMatricula}`, config);
      const updateCierreMatriculaJson = await updateCierreMatricula.json();
      const { Data } = updateCierreMatriculaJson;
      return updateCierreMatriculaJson;
      // setlistadoRequisitosMatricula(Data);
    } catch (error) {
      throw error;
    }
  }
};



let insertCierreMatriculaControlado = async (datosEstudiante, inputs) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cprograma2, cperiodo, cpersona, calumno, dperiodo } = datosEstudiante;
  const { cursosmatriculados, ntransaccion, cproceso, ccarrera, caplicacion } = inputs;
  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_ccarrera: Number(cprograma), //es el cprograma
        p_cprograma: Number(cprograma2),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_ntransaccion: Number(ntransaccion),
        p_calumno: Number(calumno),
        p_dperiodo: String(dperiodo),
        p_cursosmatriculados: cursosmatriculados,
        p_cproceso: cproceso,
        p_caplicacion: Number(caplicacion)
      }),
    };
    try {
      const updateCierreMatricula = await prometeValidarApiCierreMatricula(`${apiCierreMatriculaControlado}`, config);
      const updateCierreMatriculaJson = await updateCierreMatricula.json();
      const { Data } = updateCierreMatriculaJson;
      return updateCierreMatriculaJson;
      // setlistadoRequisitosMatricula(Data);
    } catch (error) {
      throw error;
    }
  }
};

let listado_empresas_seguro = async (
  datosEstudiante,
  setObtenerEmpresasSegurosAccidentes,
  setLoading
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion } = datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: cinstitucion,
    }),
  };
  try {
    setLoading(true);
    const lstEmpresasSeguro = await prometeValidarApi(
      `${apiListaEmpresasSeguro}`,
      config
    );
    const lstEmpresasSeguroJson = await lstEmpresasSeguro.json();
    const { Data } = lstEmpresasSeguroJson;
    setObtenerEmpresasSegurosAccidentes(Data);
    return Data
  } catch (error) {
    setLoading(false);
    throw error;
  } finally {
    setLoading(false);
  }
};

let validar_seguro_upch = async (
  datosEstudiante,
  setValidarSeguro,
  setLoading
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { ndocidentidad } = datosEstudiante;
  const { dperiodo } = datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cod_per: ndocidentidad,
      p_cod_speriodo: dperiodo,
    }),
  };
  try {
    setLoading(true);
    const validarSeguro = await prometeValidarApi(
      `${apiValidarSeguroUpch}`,
      config
    );
    const validarSeguroJson = await validarSeguro.json();
    setValidarSeguro(validarSeguroJson.Code);
  } catch (error) {
  } finally {
    setLoading(false);
  }
};
// constancias
let listado_constacias_habilitadas = async (
  datosEstudiante,
  setListConstanciaHabilitadas,
  setLoading = true
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona, calumno } =
    datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: cinstitucion,
      p_cprograma: cprograma,
      p_cperiodo: cperiodo,
      p_cpersona: cpersona,
      p_calumno: calumno,
    }),
  };
  try {
    setTimeout(() => {
      setLoading(true)
    }, 800);

    // setLoading(true);
    const lstEmpresasSeguro = await prometeValidarApi(
      `${API_CONSTACIAS_HABILITADAS}`,
      config
    );
    const lstEmpresasSeguroJson = await lstEmpresasSeguro.json();
    const { Data } = lstEmpresasSeguroJson;
    setListConstanciaHabilitadas(Data);
  } catch (error) {
    setLoading(false);
    throw error;
  } finally {
    setTimeout(() => {
      setLoading(false)
    }, 900);
  }
};

let listado_constacias_habilitadas_sinLoading = async (
  datosEstudiante,
  setListConstanciaHabilitadas
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona, calumno } =
    datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: cinstitucion,
      p_cprograma: cprograma,
      p_cperiodo: cperiodo,
      p_cpersona: cpersona,
      p_calumno: calumno,
    }),
  };
  try {
    const lstEmpresasSeguro = await prometeValidarApi(
      `${API_CONSTACIAS_HABILITADAS}`,
      config
    );
    const lstEmpresasSeguroJson = await lstEmpresasSeguro.json();
    const { Data } = lstEmpresasSeguroJson;
    setListConstanciaHabilitadas(Data);
  } catch (error) {
    throw error;
  } finally {
  }
};

let listado_constacias_datosconstancia = async (datosEstudiante) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona, calumno } =
    datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: cinstitucion,
      p_cprograma: cprograma,
      p_cperiodo: cperiodo,
      p_cpersona: cpersona,
      p_calumno: calumno,
    }),
  };
  try {
    const lstEmpresasSeguro = await prometeValidarApi(
      `${API_DATOS_CONSTACIA}`,
      config
    );
    const lstEmpresasSeguroJson = await lstEmpresasSeguro.json();
    const { Data, Code, Message } = lstEmpresasSeguroJson;
    if (Code === "0") {
      throw new Error(Message);
    }

    if (Data.length === 0) {
      throw new Error(
        "Advertencia|No hay información disponible en este momento."
      );
    }
    return Data;
  } catch (error) {
    throw error;
  } finally {
  }
};

let listado_constacias_datoshorario = async (datosEstudiante) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona, calumno } =
    datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: cinstitucion,
      p_cprograma: cprograma,
      p_cperiodo: cperiodo,
      p_cpersona: cpersona,
      p_calumno: calumno,
    }),
  };
  try {
    const lstEmpresasSeguro = await prometeValidarApi(
      `${API_DATOS_HORARIO}`,
      config
    );
    const lstEmpresasSeguroJson = await lstEmpresasSeguro.json();
    const { Data, Code, Message } = lstEmpresasSeguroJson;

    if (Code === "0") {
      throw new Error(Message);
    }
    if (Data.length === 0) {
      throw new Error(
        "Advertencia|No hay información disponible en este momento."
      );
    }
    return Data;
  } catch (error) {
    throw error;
  } finally {
  }
};

let listado_constacias_cronogramapagos = async (datosEstudiante) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { dperiodo, ndocidentidad } = datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      dperiodo: dperiodo,
      codper: ndocidentidad,
    }),
  };
  try {

    const lstEmpresasSeguro = await prometeValidarApi(
      `${API_CRONOGRAMA_PAGO}`,
      config
    );
    const lstEmpresasSeguroJson = await lstEmpresasSeguro.json();
    const { Data, Code, Message } = lstEmpresasSeguroJson;

    if (Code === "0") {
      throw new Error(Message);
    }
    if (Data.length === 0) {
      throw new Error(
        "Advertencia|No hay información disponible en este momento."
      );
    }
    return Data;

  } catch (error) {

    throw error;
  } finally {

  }
};

let insertRutaConstancia = async (datosEstudiante, inputs) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona, calumno } =
    datosEstudiante || {};
  const { cconstancia, darchivo } = inputs;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_calumno: Number(calumno),
        p_ccarrera: Number(cprograma),
        p_cconstancia: Number(cconstancia),
        p_darchivo: darchivo,
      }),
    };
    try {
      const updateRutaConstancia = await prometeValidarApi(
        `${API_RUTA_CONSTANCIA}`,
        config
      );

      const updateRutaConstanciaJson = await updateRutaConstancia.json();
      const { Data, Code, Message } = updateRutaConstanciaJson;

      if (Code === "0") {
        throw new Error(Message);
      }

      return updateRutaConstanciaJson;
    } catch (error) {
      throw error;
    }
  }
};


let listado_encuesta_listasHabilitadas = async (datosEstudiante) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona, calumno } =
    datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: Number(cinstitucion),
      p_cprograma: Number(cprograma),
      p_cperiodo: Number(cperiodo),
      p_cpersona: Number(cpersona),
      p_calumno: Number(calumno),
    }),
  };
  try {
    // setLoading(true);
    const lstencuesta_listasHabilitadas = await prometeValidarApi(
      `${API_LISTAS_HABILITADAS}`,
      config
    );
    const lstencuesta_listasHabilitadasJson =
      await lstencuesta_listasHabilitadas.json();
    const { Data } = lstencuesta_listasHabilitadasJson;

    return Data;

  } catch (error) {

    throw error;
  } finally {

  }
};

let listado_encuesta_listasPreguntas = async (cencuesta) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cencuesta: Number(cencuesta),
    }),
  };
  try {
    // setLoading(true);
    const lstencuesta_listasHabilitadas = await prometeValidarApi(
      `${API_LISTAS_PREGUNTAS}`,
      config
    );
    const lstencuesta_listasHabilitadasJson =
      await lstencuesta_listasHabilitadas.json();
    const { Data } = lstencuesta_listasHabilitadasJson;
    return Data;
  } catch (error) {
    throw error;
  } finally {
  }
};

//Seguro con pasarela de pago ----
const listado_seguroDatos = async (datosEstudiante) => {
  console.log("[Seguro 1] Iniciando listado_seguroDatos");
  console.log("[Seguro 2] Datos del estudiante:", datosEstudiante);

  try {
    const tokenGlos = JSON.parse(
      localStorage.getItem("tokenGlo") || "{}"
    );

    if (!tokenGlos?.access_token) {
      throw new Error("No se encontró el token de acceso.");
    }

    const { dperiodo, ndocidentidad } = datosEstudiante || {};

    if (!dperiodo) {
      throw new Error("No se recibió dperiodo.");
    }

    if (!ndocidentidad) {
      throw new Error("No se recibió ndocidentidad.");
    }

    const requestBody = {
      p_dperiodo: dperiodo,
      p_codper: ndocidentidad,
    };

    console.log("[Seguro 3] URL:", API_SEGURO_DATOS);
    console.log("[Seguro 4] Body enviado:", requestBody);
    console.log("[Seguro 5] Token disponible:", true);

    const response = await fetch(API_SEGURO_DATOS, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${tokenGlos.access_token}`,
      },
      body: JSON.stringify(requestBody),
    });

    console.log("[Seguro 6] HTTP status:", response.status);
    console.log("[Seguro 7] HTTP ok:", response.ok);

    // Se obtiene primero como texto para poder ver cualquier respuesta,
    // incluso cuando el backend no devuelve JSON.
    const responseText = await response.text();

    console.log("[Seguro 8] Respuesta en texto:", responseText);

    let responseJson = null;

    if (responseText) {
      try {
        responseJson = JSON.parse(responseText);
      } catch (errorJson) {
        console.error(
          "[Seguro ERROR] La respuesta no es un JSON válido:",
          errorJson
        );

        throw new Error(
          `El servidor respondió HTTP ${response.status}, pero no devolvió JSON: ${responseText}`
        );
      }
    }

    console.log("[Seguro 9] Respuesta JSON:", responseJson);

    if (!response.ok) {
      const mensajeError =
        responseJson?.message ||
        responseJson?.Message ||
        responseJson?.mensaje ||
        responseJson?.error ||
        responseJson?.Error ||
        responseText ||
        `Error HTTP ${response.status}`;

      throw new Error(mensajeError);
    }

    const data = responseJson?.Data ?? responseJson?.data;

    console.log("[Seguro 10] Data recibida:", data);
    console.log("[Seguro 11] ¿Data es arreglo?:", Array.isArray(data));

    if (data === undefined || data === null) {
      throw new Error(
        "El API respondió correctamente, pero no contiene Data."
      );
    }

    // ModalPagoSeguro espera un objeto, no un arreglo.
    const seguroDatos = Array.isArray(data)
      ? data[0]
      : data;

    console.log("[Seguro 12] Objeto normalizado:", seguroDatos);
    console.log("[Seguro 13] nmonto:", seguroDatos?.nmonto);

    if (!seguroDatos) {
      throw new Error(
        "El API no devolvió información del seguro."
      );
    }

    if (
      seguroDatos.nmonto === undefined ||
      seguroDatos.nmonto === null
    ) {
      console.warn(
        "[Seguro ADVERTENCIA] El API no devolvió el campo nmonto:",
        seguroDatos
      );
    }

    return seguroDatos;
  } catch (error) {
    console.error("[Seguro ERROR] Error completo:", error);
    console.error("[Seguro ERROR] Mensaje:", error?.message);

    throw error;
  }
};

let listado_seguroPreliquidacion = async (datosEstudiante, p_ctip_pago) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { ndocidentidad } = datosEstudiante;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_nro_documento: ndocidentidad,
      p_ctip_pago: p_ctip_pago
    }),
  };
  try {
    // setLoading(true);
    const listado_seguroPreliquidacion = await prometeValidarApi(
      `${API_SEGURO_PRELIQUIDACION}`,
      config
    );
    const listado_seguroPreliquidacionJson =
      await listado_seguroPreliquidacion.json();
    const { Data } = listado_seguroPreliquidacionJson;

    return Data;

  } catch (error) {

    throw error;
  } finally {

  }
};

let insertPagoExito = async (p_cpreliquidacion, p_nro_documento) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cpreliquidacion: String(p_cpreliquidacion),
        p_nro_documento: String(p_nro_documento),
      }),
    };
    try {
      const updatePagoExito = await prometeValidarApi(
        `${API_REGISTRO_PAGOEXITO}`,
        config,
        "insertPagoExito"
      );

      const updatePagoExitoJson = await updatePagoExito.json();
      const { Data, Code, Message } = updatePagoExitoJson;

      if (Code === "0") {
        throw new Error(Message);
      }
      return updatePagoExitoJson;
      // setlistadoRequisitosMatricula(Data);
    } catch (error) {
      throw error;
    }
  }
};

let insertRespuestaPasarela = async (datosEstudiante, inputs) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante || {};
  const {
    p_cpreliquidacion,
    p_nnropedido,
    p_ntipopago,
    p_montopago,
    p_nexistoso,
    p_ntrasaccion,
    p_ftransacion,
    p_drespuesta,
    p_ntarjeta,
    p_ctipotarjeta,
    p_ctip_pago,
    p_gpagado,
    p_operation_id
  } = inputs;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_ncodpreliq: Number(p_cpreliquidacion),
        p_nnropedido: Number(p_nnropedido),
        p_ntipopago: Number(p_ntipopago),
        p_montopago: Number(p_montopago),
        p_nexistoso: Number(p_nexistoso),
        p_ntrasaccion: String(p_ntrasaccion),
        p_ftransacion: p_ftransacion,
        p_drespuesta: String(p_drespuesta),
        p_ntarjeta: String(p_ntarjeta),
        p_ctipotarjeta: String(p_ctipotarjeta),
        p_ctip_pago: p_ctip_pago,
        p_gpagado: p_gpagado,
        p_operation_id: p_operation_id

      }),
    };
    try {
      const updateRespuestaPasarela = await prometeValidarApiPasarela(
        `${API_REGISTRO_RESPUESTAPASARELA}`,
        config
      );

      const updateRespuestaPasarelaJson = await updateRespuestaPasarela.json();
      const { Data, Code, Message } = updateRespuestaPasarelaJson;

      if (Code === "0") {
        throw new Error(Message);
      }
      return updateRespuestaPasarelaJson;
      // setlistadoRequisitosMatricula(Data);
    } catch (error) {
      throw error;
    }
  }
};

let formatNumber = (value) => {
  var numeroInicial = value;
  var formato = numeroInicial.toFixed(2);
  var resultado = formato.replace(/\B(?=(\d{3})+(?!\d))/g, "");
  return String(resultado);
};

const fechaActualSafetyPay = () => {
  var fechaActual = new Date();
  var formatoFecha = fechaActual.toISOString().replace("Z", "");

  return String(formatoFecha);
};


let urlPasarelaSafetyPay = async (datosPayment) => {

  const {
    value,
    currency_code,
    phone_number,
    first_name,
    last_names,
    emails,
    language_code,
    merchant_sales_id,
    application_id,
    product_id,
  } = datosPayment;
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ` + tokenGlos.access_token,
      "X-Api-Key": KEY_SAFETY_PAY,
    },
    body: JSON.stringify({
      merchant_set_pay_amount_data: {
        merchant_currency_code: currency_code,
        country_code: "PER",
      },
      sales_amount: {
        value: formatNumber(value),
        currency_code: currency_code,
      },
      shopper: {
        phone: {
          phone_type: "Mobile",
          phone_country_code: "51",
          phone_number: String(phone_number),
          is_sms_enabled: false,
        },
        shopper_type: "Person",
        first_name: first_name,
        last_names: last_names,

        email: {
          email_address: emails,
          purpose: "Personal",
        },
      },
      payment_ok_url: "https://www.safetypay.com/success.com",
      payment_error_url: "https://www.safetypay.com/error.com",
      filter_payment_by: "",
      merchant_set_pay_amount: false,
      expiration_time_minutes: 480,
      language_code: String(language_code),
      custom_merchant_name: "M_TEST",
      merchant_sales_id: merchant_sales_id,
      requested_payment_type: "StandardorBoleto",
      application_id: 7,
      product_id: String(product_id),
      transaction_email: emails,
      send_email_shopper: true,
      request_datetime: fechaActualSafetyPay(),
    }),
  };
  try {
    const listado_seguroPreliquidacion = await prometeValidarApi2(
      `${apiPasarelaSafetyPay}`,
      config
    );
    const listado_seguroPreliquidacionJson =
      await listado_seguroPreliquidacion.json();

    return listado_seguroPreliquidacionJson;

  } catch (error) {
    throw error;
  } finally {
  }
};

let sesionesHabilitadas = async (datosEstudiante) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: Number(cinstitucion),
      p_cprograma: Number(cprograma),
      p_cperiodo: Number(cperiodo),
      p_cpersona: Number(cpersona),
    }),
  };
  try {
    const listado_sesionesHabilitadas = await prometeValidarApi(
      `${API_SESIONESHABILITADAS}`,
      config
    );
    const listado_sesionesHabilitadasJson =
      await listado_sesionesHabilitadas.json();
    const { Data } = listado_sesionesHabilitadasJson;
    return Data;
  } catch (error) {
    throw error;
  } finally {
  }
};

let listado_asignaturas_habilitadasSinLoading = async (datosEstudiante) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const { cinstitucion, cprograma, cperiodo, cpersona } = datosEstudiante;

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      p_cinstitucion: Number(cinstitucion),
      p_cprograma: Number(cprograma),
      p_cperiodo: Number(cperiodo),
      p_cpersona: Number(cpersona),
    }),
  };
  try {
    const listaCursos = await prometeValidarApi(`${apiAsignatura}`, config);

    const listaCursosJson = await listaCursos.json();
    const { Data } = listaCursosJson;

    return Data;
  } catch (error) {
    throw error;
  } finally {
  }
};

let insertarApiUploadFile = async ({ nombreFile, base64File }) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ` + tokenGlos.access_token,
    },
    body: JSON.stringify({
      nombreFile: String(nombreFile),
      base64File: base64File,
    }),
  };
  try {
    const insertarUploadFile = await prometeValidarApi(
      `${API_UPLOADFILE}`,
      config
    );
    const insertarUploadFileJson = await insertarUploadFile.json();
    const { Data } = insertarUploadFileJson;
    return Data;
  } catch (error) {
    throw error;
  } finally {
  }
};

let insertarApiRespuesta = async (datosEstudiante, parametros) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const { cinstitucion, cprograma, cperiodo, cpersona, calumno } =
    datosEstudiante || {};
  const { cencuesta, cadena_respuestas } = parametros;

  if (tokenGlos) {
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: Number(cinstitucion),
        p_cprograma: Number(cprograma),
        p_cperiodo: Number(cperiodo),
        p_cpersona: Number(cpersona),
        p_calumno: Number(calumno),
        p_ccarrera: Number(cprograma),
        p_cencuesta: Number(cencuesta),
        p_cadena_respuestas: String(cadena_respuestas),
      }),
    };
    try {
      const updateApiRespuesta = await prometeValidarApi(
        `${API_RESPUESTAS}`,
        config
      );

      const updateApiRespuestaJson = await updateApiRespuesta.json();
      const { Data, Code, Message } = updateApiRespuestaJson;

      if (Code === "0") {
        throw new Error(Message);
      }
      return updateApiRespuestaJson;
    } catch (error) {
      throw error;
    }
  }
};

let desencriptarTokenSesion = (pass) => {
  let token = pass == null ? "" : pass;
  // Decrypt
  var bytes = CryptoJS.AES.decrypt(token, `${keyPassLogin}`);
  var originalText = bytes.toString(CryptoJS.enc.Utf8);

  return originalText;
};

let listado_datosEstudiante_logeadoSinLoading = async (
  setObtenerDatosEstudianteSinFiltro,
  setObtenerDatosEstudiante,
  datosEstudiante
) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

  let codEstud = localStorage.getItem("token");
  let desencriptarCode = desencriptarTokenSesion(codEstud);
  let condicionDeCode = desencriptarCode == "" ? false : desencriptarCode;
  if (condicionDeCode !== false) {
    const { cprograma, cperiodo } = datosEstudiante;

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cusuario: condicionDeCode,
        p_cinstitucion: codigoIntitucion,
      }),
    };
    try {
      const listaEstudiante = await prometeValidarApi(
        `${apiDatosEstudiante}`,
        config
      );
      const listaEstudianteJson = await listaEstudiante.json();
      const { Data, Code, Message } = listaEstudianteJson;
      if (Code === "0") {
        throw new Error(Message);
      }
      setObtenerDatosEstudianteSinFiltro(Data);
      let dataDefault = Data.filter((info) => {
        return info.cprograma == cprograma && info.cperiodo == cperiodo;
      });

      setObtenerDatosEstudiante([]);
      setObtenerDatosEstudiante(dataDefault[0]);
    } catch (error) {

      throw error;
    } finally {

    }
  }
};


let postGenerarProcesarProyeccionMutation = async (dataPayload) => {
  try {
    const tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(tokenGlos && tokenGlos.access_token && {
          Authorization: `Bearer ${tokenGlos.access_token}`,
        }),
      },
      body: JSON.stringify(dataPayload),
    };
    const response = await prometeValidarApi(`${apiGenerarProcesoEstudiante}`, config, "generarProceso");
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

let obtenerErroresProcesoMatricula = async (params) => {
  const tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const config = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(tokenGlos && tokenGlos.access_token && {
        Authorization: `Bearer ${tokenGlos.access_token}`,
      }),
    },
    body: JSON.stringify(params)
  };
  try {
    const response = await prometeValidarApi(`${apiValidarErrorProceso}`, config, "obtenerErroresValidacion"
    );
    // Convertimos la respuesta a JSON y la retornamos
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};

const generateCproceso = () => {
  const date = new Date();
  const YYYY = date.getFullYear();
  const MM = String(date.getMonth() + 1).padStart(2, "0");
  const DD = String(date.getDate()).padStart(2, "0");
  const HH = String(date.getHours()).padStart(2, "0");
  const mm = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  return `${YYYY}${MM}${DD}${HH}${mm}${ss}`;
};

let getValueGeneral = async (id = 1) => {
  let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));
  const config = {
    method: "GET",
  };
  try {
    // setLoading(true);
    const getValue = await prometeValidarApi(
      `https://92y9wfjrji.execute-api.us-east-1.amazonaws.com/DEV/general/getvalue?param=${id}`,
      config
    );
    const getValueJson =
      await getValue.json();
    const { Data } = getValueJson;

    return Data;

  } catch (error) {

    throw error;
  } finally {

  }
};



export {
  getValueGeneral,
  obtenerErroresProcesoMatricula,
  generateCproceso,
  update_paso,
  update_datosPersonales,
  update_seguroEstudiante,
  listado_datos_personales,
  listado_asignaturas_estudiante,
  listado_grupos_habilitados,
  listado_empresas_seguro,
  listado_asignaturas_estudiante_sinLoading,
  insertCierreMatricula,
  insertCierreMatriculaControlado,
  validar_seguro_upch,
  listado_constacias_habilitadas,
  listado_constacias_datosconstancia,
  listado_constacias_datoshorario,
  listado_constacias_cronogramapagos,
  insertRutaConstancia,
  listado_constacias_habilitadas_sinLoading,
  listado_seguroDatos,
  listado_seguroPreliquidacion,
  insertPagoExito,
  insertRespuestaPasarela,
  listado_encuesta_listasHabilitadas,
  listado_encuesta_listasPreguntas,
  sesionesHabilitadas,
  listado_asignaturas_habilitadasSinLoading,
  insertarApiUploadFile,
  insertarApiRespuesta,
  listado_datosEstudiante_logeadoSinLoading,
  listado_datos_personalesReturn,
  urlPasarelaSafetyPay,
  postGenerarProcesarProyeccionMutation,
};
